const VariantDisplayBadges = ({ badges, selectedVariant }) => ({
  selectedVariant: "",
  badges: {},
  get selectedVariantBadges() {
    return this.badges[this.selectedVariant] ?? { badge_gray: "", badge_accent: "" };
  },
  init() {
    if (!badges) return console.error("[VariantDisplayBadges] Missing badges prop.");

    const queryParams = new URLSearchParams(window.location.search);
    const variant = queryParams.get("variant");

    this.badges = badges;
    const firstAvailableVariant = Object.keys(this.badges).find(
      id => !this.badges[id].is_end_of_life && this.badges[id].is_available
    );

    if (selectedVariant) {
      this.selectedVariant = selectedVariant;
    } else if (variant && this.badges[variant]) {
      this.selectedVariant = variant;
    } else if (firstAvailableVariant) {
      this.selectedVariant = firstAvailableVariant;
    } else {
      this.selectedVariant = Object.keys(this.badges)[0];
    }

    document.addEventListener("variant:changed", event => {
      if (!this.badges[event.detail.variant.id]) return;

      this.selectedVariant = String(event.detail.variant.id);
    });
  }
});

export default VariantDisplayBadges;
